import React from 'react';

const ToggleSwitch = ({
  checked,
  onChange,
  disabled = false,
  label = '',
  className = ''
}) => {
  return (
    <div className={`flex justify-start items-center ${className}`}>
      {label && <span className="text-sm text-gray-700 mr-3">{label}</span>}
      <label className={`inline-flex items-center cursor-pointer w-18 ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}>
        <input
          type="checkbox"
          checked={checked}
          onChange={onChange}
          disabled={disabled}
          className="sr-only peer"
        />
        <div className={`
          relative w-16 h-8 
          ${checked ? 'bg-green-500' : 'bg-gray-300'}
          peer-focus:outline-none peer-focus:ring-3 peer-focus:ring-green-200 
          rounded-full peer 
          peer-checked:after:translate-x-8
          peer-checked:after:border-white 
          after:content-[''] after:absolute after:top-1 after:start-1 after:bg-white 
          after:rounded-full after:h-6 after:w-6 after:transition-all
        `}>
        </div>
      </label>
    </div>
  );
};

export default ToggleSwitch;